// extracted by css-extract-rspack-plugin
export default {"tooltipBlock":"tooltipBlock-CvgYsu","tooltipTitle":"tooltipTitle-wIrhkU","tooltipMetrics":"tooltipMetrics-e51xy8"};